module.exports = {
  "/achievements/:publicId/:language/:template/:achieverName/:trackName": {
    "name": "achievements-public",
    "success": {
      "achievement loaded": [
        "ACHIEVEMENT_LOADED"
      ],
      "achievement missing": [
        "ACHIEVEMENT_MISSING"
      ]
    }
  }
};